import React from 'react';
import '../App.css';
import FooterChinese from '../components/FooterChinese';
import TopBarChinese from '../components/TopBarChinese';

function CareerChinese() {
  return (
    <div className='App'>
        <TopBarChinese />
    <div style={{
      padding: '40px 20px',
      maxWidth: '1200px',
      margin: '0 auto',
      marginTop: '10vh'
    }}>
      <h1 style={{
        fontSize: '2.5rem',
        marginBottom: '30px',
        textAlign: 'center'
      }}>加入我们的团队</h1>

      <div style={{
        background: 'white',
        padding: '30px',
        borderRadius: '10px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '30px'
      }}>
        <h2 style={{ marginBottom: '20px' }}>当前职位机会</h2>
        <p style={{ marginBottom: '20px' }}>
          在Connection Health Care，我们一直在寻找有热情的专业人士加入我们的团队，
          他们与我们一样致力于为长者提供卓越的护理服务。加入我们的专业团队，一起为改善人们的生活做出真正的贡献。
        </p>

        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ marginBottom: '15px' }}>空缺职位：</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ 
              marginBottom: '20px',
              padding: '20px',
              border: '1px solid #eee',
              borderRadius: '5px'
            }}>
              <h4 style={{ marginBottom: '10px' }}>个人支持工作者 (PSW)</h4>
              <p style={{ marginBottom: '10px' }}>提供全职和兼职职位</p>
              
              <div style={{ marginTop: '15px' }}>
                <h5 style={{ marginBottom: '10px', fontWeight: 'bold' }}>職位描述：</h5>
                
                <h6 style={{ marginBottom: '8px', fontWeight: 'bold' }}>工作簡介</h6>
                <p style={{ marginBottom: '15px', lineHeight: '1.5' }}>
                  我們正在尋找有愛心且敬業的醫療照護人員／個人支援工作者（PSW），在各種照護環境中提供必要的支持，包括：輔助生活設施、護理之家及居家照護。
                  理想人選將在提升長者及身心障礙者的生活品質方面扮演關鍵角色，透過個人化的照護與協助，滿足其獨特需求。
                </p>

                <h6 style={{ marginBottom: '8px', fontWeight: 'bold' }}>工作職責</h6>
                <div style={{ marginBottom: '15px', lineHeight: '1.4', textAlign: 'left' }}>
                  <p style={{ margin: '5px 0' }}>協助客戶執行日常生活活動，如沐浴、更衣、個人清潔及餐食準備。</p>
                  <p style={{ margin: '5px 0' }}>按照醫囑給予藥物，並觀察是否有副作用或身體狀況的變化。</p>
                  <p style={{ margin: '5px 0' }}>提供陪伴與情感支持，促進客戶整體身心福祉。</p>
                  <p style={{ margin: '5px 0' }}>執行簡單家務，維持客戶生活環境的整潔與安全。</p>
                  <p style={{ margin: '5px 0' }}>協助身心障礙者完成日常活動及生活安排。</p>
                  <p style={{ margin: '5px 0' }}>協助行動與轉移，確保全程安全。</p>
                  <p style={{ margin: '5px 0' }}>紀錄照護內容，並將客戶健康狀況或行為變化回報予主管護理人員或醫療專業人員。</p>
                  <p style={{ margin: '5px 0' }}>透過參與有意義的活動，特別針對失智照護對象，促進其認知功能。</p>
                </div>

                <h6 style={{ marginBottom: '8px', fontWeight: 'bold' }}>技能需求</h6>
                <div style={{ marginBottom: '15px', lineHeight: '1.4', textAlign: 'left' }}>
                  <p style={{ margin: '5px 0' }}>具有輔助生活設施、護理之家或居家照護相關工作經驗者尤佳。</p>
                  <p style={{ margin: '5px 0' }}>熟悉藥物給予流程與相關最佳實務。</p>
                  <p style={{ margin: '5px 0' }}>具備良好的組織能力，能同時維持整潔環境並有效處理多項任務。</p>
                  <p style={{ margin: '5px 0' }}>對長者與身心障礙者展現同理與關懷的態度。</p>
                  <p style={{ margin: '5px 0' }}>優異的溝通能力，能與客戶、家庭及醫護團隊有效互動。</p>
                  <p style={{ margin: '5px 0' }}>能以耐心、同理心與理解心面對失智或其他認知障礙的客戶。</p>
                  <p style={{ margin: '5px 0' }}>具備彈性，能依照客戶需求與時間表調整服務安排，並提供穩定支持。</p>
                </div>

                <p style={{ marginBottom: '10px', fontStyle: 'italic' }}>
                  加入我們專業且充滿熱忱的團隊，一同為有需要的人創造改變！
                </p>

                <p style={{ marginBottom: '5px' }}><strong>職位類型：</strong> 全職 / 兼職</p>
                <p style={{ marginBottom: '5px' }}><strong>語言要求：</strong> 英文（優先考慮）</p>
                <p><strong>工作地點：</strong> 實體到場（In-person）</p>
              </div>
            </li>

            {/* <li style={{ 
              marginBottom: '20px',
              padding: '20px',
              border: '1px solid #eee',
              borderRadius: '5px'
            }}>
              <h4 style={{ marginBottom: '10px' }}>注册护士 (RN)</h4>
              <p style={{ marginBottom: '10px' }}>提供全职职位</p>
              <p style={{ textAlign: 'center', marginBottom: '10px' }}>要求：</p>
              <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                <p style={{ margin: '5px 0' }}>持有CNO的当前注册护士执照</p>
                <p style={{ margin: '5px 0' }}>至少2年护理经验</p>
                <p style={{ margin: '5px 0' }}>优先考虑有老年护理经验者</p>
                <p style={{ margin: '5px 0' }}>强大的临床评估能力</p>
                <p style={{ margin: '5px 0' }}>优秀的团队协作能力</p>
              </div>
            </li> */}
          </ul>
        </div>

        <div style={{
          background: '#f9f9f9',
          padding: '30px',
          borderRadius: '5px',
          marginBottom: '30px'
        }}>
          <h3 style={{ marginBottom: '20px' }}>立即申請</h3>
          <form style={{ display: 'grid', gap: '20px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>名字 *</label>
                <input 
                  type="text" 
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>姓氏 *</label>
                <input 
                  type="text" 
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>申請職位 *</label>
              <select 
                required
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}
              >
                <option value="">選擇職位</option>
                <option value="PSW">個人支持工作者 (PSW)</option>
                <option value="RN">註冊護士 (RN)</option>
              </select>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>居住城市 *</label>
              <input 
                type="text" 
                required
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>電話號碼 *</label>
                <input 
                  type="tel" 
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px' }}>電子郵件 *</label>
                <input 
                  type="email" 
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>是否有車 *</label>
              <select 
                required
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}
              >
                <option value="">請選擇</option>
                <option value="yes">是</option>
                <option value="no">否</option>
              </select>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>可工作時段 *</label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input type="checkbox" /> 早班
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input type="checkbox" /> 午班
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input type="checkbox" /> 晚班
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input type="checkbox" /> 平日
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input type="checkbox" /> 週末
                </label>
              </div>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>如何得知我們的職位空缺？ *</label>
              <select 
                required
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}
              >
                <option value="">請選擇</option>
                <option value="website">公司網站</option>
                <option value="jobBoard">招聘網站</option>
                <option value="socialMedia">社交媒體</option>
                <option value="referral">員工推薦</option>
                <option value="other">其他</option>
              </select>
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>上傳簡歷 *</label>
              <input 
                type="file" 
                accept=".pdf,.doc,.docx"
                required
                style={{
                  width: '100%',
                  padding: '8px'
                }}
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>補充說明</label>
              <textarea 
                style={{
                  width: '100%',
                  padding: '8px',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  minHeight: '100px'
                }}
              ></textarea>
            </div>

            <button 
              type="submit"
              style={{
                background: '#004080',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              提交申請
            </button>
          </form>
        </div>
      </div>
    </div>
    <FooterChinese />
    </div>
  );
}

export default CareerChinese;
